import { useCallback, MouseEvent, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { getShowBuyerDetailsState, getBuyerDetailsPath } from '~/lib/users/url';

/**
 * Hook for managing buyer details visibility state
 * Provides the current state and a toggle function
 */
export const useBuyerDetails = () => {
  const [isToggling, setIsToggling] = useState<boolean>(false);

  const searchParams = useSearchParams();
  const { replace, push } = useRouter();

  // Get the current state from URL params
  const showBuyerDetails = getShowBuyerDetailsState(searchParams);

  // Toggle function that updates the URL
  const toggleBuyerDetails = useCallback((pathname?: string) => {
    // Use provided pathname or current location
    const currentPath = pathname || window.location.pathname;
    const path = getBuyerDetailsPath(searchParams, currentPath);

    // Use replace or push based on what's available
    if (replace) {
      replace(path);
    } else if (push) {
      push(path);
    }
  }, [searchParams, replace, push]);

  // Event handler version for onClick props
  const handleToggleBuyerDetails = useCallback((e?: MouseEvent) => {
    e?.preventDefault();
    setIsToggling(true);

    toggleBuyerDetails();

    setIsToggling(false);
  }, [toggleBuyerDetails]);

  return {
    /**
    * @deprecated
    * Use showSpeculatorDetails instead
    */
    showBuyerDetails,
    /**
    * @deprecated
    * Use toggleSpeculatorDetails instead
    */
    toggleBuyerDetails,
    /**
    * @deprecated
    * Use handleToggleSpeculatorDetails instead
    */
    handleToggleBuyerDetails,
    isToggling,

    showSpeculatorDetails: showBuyerDetails,
    toggleSpeculatorDetails: toggleBuyerDetails,
    handleToggleSpeculatorDetails: handleToggleBuyerDetails,
  };
};
